import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import {DOSSIER_STATE} from 'front-onceforall-core/dist/utils/dossiers';
import ListItemView from './ListItemView';
import documentService from '../../../services/document/DocumentService';
import {captureError} from '../../../utils/log';
import config from '../../../../config';
import organisationService from '../../../services/organisation/OrganisationService';
import {TYPES} from '../utils/utils';

function ListItemContainer(props) {
  const history = useHistory();

  const [organisation, setOrganisation] = React.useState({...props.organisation});
  const [dossierState, setDossierState] = React.useState(null);

  React.useEffect(() => {
    const aborter = new AbortController();
    setOrganisation({...props.organisation});

    if (props.type !== TYPES.SUBCONTRACTOR) {
      return false;
    }

    organisationService.get(props.organisation.organisationId, aborter.signal)
      .then(({interoperatedOrganisation}) => {
        setOrganisation({...props.organisation, interoperatedOrganisation});
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          captureError('Error while fetching subcontractor interoperated data', error);
        }
      });

    if (!props.organisation.depositor) {
      setDossierState(DOSSIER_STATE.DEPOSITOR_SERVICE_DEACTIVATED);
      return false;
    }

    if (config.featureFlags.noSubcontractorsDossierStateCalls) {
      return false;
    }

    setDossierState(null);

    documentService.getDossierState(props.organisation.organisationId, props.dossierCountry, aborter.signal)
      .then(response => {
        setDossierState(response.dossierState);
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          captureError('Error while fetching subcontractor dossier state', error);
        }
      });

    return () => {
      aborter.abort();
    };
  }, [props.organisation, props.dossierCountry]);

  function handleLinkOrganisation(event, organisationId) {
    event.preventDefault();
    event.stopPropagation();
    history.push(`/${props.type}/${organisationId}`);
  }

  return (
    <ListItemView
      organisation={organisation}
      type={props.type}
      hasInterventionInProject={props.hasInterventionInProject}
      onMenuBtnClick={props.onMenuBtnClick}
      onDeleteOrganisation={props.onDeleteOrganisation}
      onClickOrganisation={handleLinkOrganisation}
      dossierState={dossierState}
    />
  );
}

ListItemContainer.propTypes = {
  type: PropTypes.oneOf(Object.values(TYPES)).isRequired,
  organisation: PropTypes.object.isRequired,
  hasInterventionInProject: PropTypes.bool,
  onMenuBtnClick: PropTypes.func.isRequired,
  onDeleteOrganisation: PropTypes.func.isRequired,
  dossierCountry: PropTypes.string
};

export default ListItemContainer;
